// Classic › players (#1119): the Players and Teams list pages.

const en = {
  players: {
    subtitle: 'Meet the athletes who compete at the highest level',
    search: 'Search players by name...',
    team: 'Team',
    allTeams: 'All Teams',
    position: 'Position',
    allPositions: 'All Positions',
    clear: 'Clear',
    count: (n: number) => (n === 1 ? `${n} Player` : `${n} Players`),
    gridView: 'Grid view',
    listView: 'List view',
    noneFound: 'No Players Found',
    noneYet: 'No Players Yet',
    tryAdjusting: 'Try adjusting your search or filters',
    rostersEmpty: 'Rosters show here once teams add players.',
    clearFilters: 'Clear Filters',
    /** #583: the group for players outside every live division. */
    otherPlayers: 'Other players',
    loadMore: (shown: number, total: number) => `Load More (${shown} of ${total})`,
    silhouette: 'Player silhouette',
  },
  teams: {
    subtitle: 'Meet the organizations competing at the highest level',
    search: 'Search teams by name or city...',
    count: (n: number) => (n === 1 ? `${n} Team` : `${n} Teams`),
    noneFound: 'No Teams Found',
    tryAdjusting: 'Try adjusting your search',
    noneAvailable: 'No teams available',
    clearSearch: 'Clear Search',
    otherTeams: 'Other teams',
  },
}

export default en
